import moment from "moment";
import { DATE_FORMAT, BUILD_PATH } from "../constants/app.constants";
import { URL } from "../constants/app.constants";

type ParamBody = {
  [key: string]: string | number | Date | null | boolean | undefined;
};
export const isLoggedIn = () => {
  if (
    localStorage.getItem("username") &&
    localStorage.getItem("empId") &&
    localStorage.getItem("uname")
  ) {
    return {
      signedIn: true,
    };
  } else
    return {
      signedIn: false,
    };
};

export const callApi = async (
  command: string,
  params: ParamBody,
  type: string
) => {
  const formData = new FormData();
  formData.append("command", command);
  formData.append("params", JSON.stringify(params));
  formData.append("type", type);

  const response = await fetch(`${URL}`, {
    method: "POST",
    body: formData,
  });
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  return response.json();
};
